export default __webpack_public_path__ + "static/media/logo.f99c8aae.png";